export const ORDER_DEMO_TOUR = 'Demo Order';
export const ORDER_DEMO_TYPE = 'order-demo-type';
export const DEMO_STORE = 'Demo Store';
export const DEFAULT_DEMO_FULFILLMENT_PLAN_ID = 0;
export const CREATE_TEST_LABEL = 'createTestLabel';
const DEMO_PRODUCT_SKU_SOCKS = 'SOC-1[DEMO]';
const DEMO_PRODUCT_SKU_TSHIRT = 'GSD-1L[DEMO]';
const DEMO_PRODUCT_NAME_SOCKS = 'ShipStation Socks [DEMO]';
const DEMO_PRODUCT_NAME_TSHIRT = 'ShipStation T-SHIRT [DEMO]';

export const demoOrder1 = {
  shipByDateTime: null,
  paidDateTime: null,
  holdUntilDateTime: null,
  orderDateTime: null,
  items: [
    {
      isGift: false,
      name: DEMO_PRODUCT_NAME_TSHIRT,
      productId: null,
      productThumbnailUrl:
        'https://cdn11.bigcommerce.com/s-ys6cuq3i3w/images/stencil/1280x1280/attribute_rule_images/1_source_1597329696.jpg',
      quantityFulfilled: 0,
      quantity: 1,
      quantityOrdered: 1,
      quantityPlanned: 0,
      quantityReturned: 0,
      salesOrderItemId: null,
      sku: DEMO_PRODUCT_SKU_TSHIRT,
      totalPrice: {
        value: 0,
        code: 'USD',
      },
      unitPrice: {
        value: '20.00',
        code: 'USD',
      },
    },
    {
      isGift: false,
      name: DEMO_PRODUCT_NAME_SOCKS,
      productId: null,
      productThumbnailUrl:
        'https://cdn11.bigcommerce.com/s-ys6cuq3i3w/images/stencil/1280x1280/products/115/389/Socks_2__62412.1597268351.jpg?c=1',
      quantityFulfilled: 0,
      quantity: 2,
      quantityOrdered: 2,
      quantityPlanned: 0,
      quantityReturned: 0,
      salesOrderItemId: null,
      sku: DEMO_PRODUCT_SKU_SOCKS,
      totalPrice: {
        value: 0,
        code: 'USD',
      },
      unitPrice: {
        value: '10.00',
        code: 'USD',
      },
    },
  ],
  amountSummary: {
    shippingPaid: {
      value: 4.99,
      code: 'USD',
    },
    taxPaid: {
      value: 2.5,
      code: 'USD',
    },
    totalPaid: {
      value: 47.49,
      code: 'USD',
    },
  },
  soldTo: {
    email: '',
    name: 'John Shippy',
  },
  isGift: false,
  shipToAddress: {
    countryCode: 'US',
    email: 'customer@example.com',
    name: 'John Shippy',
    line1: '4301 Bull Creek Rd',
    line2: 'Suite 300',
    city: 'Austin',
    state: 'TX',
    postalCode: '78731',
  },
  orderNumber: ORDER_DEMO_TOUR,
  createGuid: null,
  store: {
    storeGuid: null,
  },
  storeGuid: null,
};

export const demoProducts = [
  {
    active: true,
    name: DEMO_PRODUCT_NAME_TSHIRT,
    sku: DEMO_PRODUCT_SKU_TSHIRT,
    productType: 'Standalone',
    thumbnailUrl: 'https://cdn11.bigcommerce.com/s-ys6cuq3i3w/images/stencil/1280x1280/attribute_rule_images/1_source_1597329696.jpg',
    dimensionUnitOfMeasureId: 'Inches',
    price: 20,
    isBundle: false,
  },
  {
    sellerId: null,
    active: true,
    name: DEMO_PRODUCT_NAME_SOCKS,
    sku: DEMO_PRODUCT_SKU_SOCKS,
    productType: 'Standalone',
    price: 10,
    thumbnailUrl: 'https://cdn11.bigcommerce.com/s-ys6cuq3i3w/images/stencil/1280x1280/products/115/389/Socks_2__62412.1597268351.jpg?c=1',
    dimensionUnitOfMeasureId: 'Inches',
  },
];

export const demoTag = {
  name: 'Demo',
  hexColor: '#256FEB',
};

export const demoShipFrom = {
  city: 'El Segundo',
  state: 'CA',
  countryCode: 'US',
  postalCode: '90245',
  name: 'Demo Ship from',
  line1: '1990 E Grand Ave',
  company: 'Demo Company',
  phone: '5555555555',
  isDefault: true,
  originAddress: {
    countryCode: 'US',
    ianaTimeZone: 'America/Los_Angeles',
    name: 'John Shippy',
    email: 'myEmail@example.com',
    company: 'Demo Company',
    line1: '1990 E Grand Ave',
    city: 'El Segundo',
    state: 'CA',
    postalCode: '90245',
    phone: '5555555555',
  },
  returnAddress: {
    countryCode: 'US',
    ianaTimeZone: 'America/Los_Angeles',
    name: 'John Shippy',
    email: 'myEmail@example.com',
    company: 'Demo Company',
    line1: '1990 E Grand Ave',
    city: 'El Segundo',
    state: 'CA',
    postalCode: '90245',
    phone: '5555555555',
  },
};
